import {createI18n} from 'vue-i18n';
import {registerMessageCompiler} from '@intlify/core-base';
import router from '../router';

const localeName = getLocaleName();

function getLocaleName() {
  switch (window.locale) {
    case 'en-GB':
      return 'gb';
    default:
      return window.locale;
  }
}

// Кастомный messageCompiler полностью обходит компилятор intlify-формата. Это критично:
// локали (config/locales, общие с Rails) содержат ~1500 '%s' и строки с литеральными '|',
// '{', '}', '@' — стандартный компилятор трактовал бы их как синтаксис. Формат — sprintf:
// последовательная замена '%s' значениями из массива, остальное — литеральный текст.
function sprintfCompiler(message, {key}) {
  if (typeof message !== 'string') {
    return () => key;
  }
  return (ctx) => {
    let str = message;
    const values = ctx.values;
    const list = Array.isArray(values) ? values : Object.values(values ?? {});
    list.forEach((val) => {
      // функция-замена, чтобы символ '$' в значении не интерпретировался String.replace
      str = str.replace('%s', () => String(val));
    });
    return str;
  };
}

// ВАЖНО: опция createI18n({messageCompiler}) в legacy-режиме МОЛЧА игнорируется
// (convertComposerOptions в vue-i18n@9 ее не пробрасывает), поэтому регистрируем
// компилятор глобально — ядро intlify использует зарегистрированный компилятор,
// когда в контексте не задан свой (см. @intlify/core-base createCoreContext).
registerMessageCompiler(sprintfCompiler);

export const i18n = createI18n({ // import {i18n} from '[some-path]/startup/i18n.js' дает доступ к локализации в любом месте приложения
  legacy: true, // Options API: $t / this.$i18n
  locale: localeName,
  fallbackLocale: localeName,
  messages: {}, // default empty
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlInMessage: 'off', // в локалях есть сырой HTML (рендерится через v-html)
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});

export function loadLanguageAsync() { // Позволяет загружать локализацию асинхронно
  return import(`../localisation/${window.locale}.json`).then(
      (messages) => {
        i18n.global.setLocaleMessage(localeName, messages.default);
        i18n.global.locale = localeName; // legacy-режим: locale — обычная строка
        return localeName;
      },
  ).catch(()=>{
    router.replace('/404.com.html').catch(() => {}); // глушим отклоненный промис навигации
  });
}
